<gipi-abstract-form id="dialogClientSummary"
                    name="dialogClientSummary"
                    [dialog]="true">
    <gipi-toolbar mat-dialog-title
                  id="toolbarDialogClientSummary">
        Produtos mais comprados
    </gipi-toolbar>

    <div mat-dialog-content
         fxLayout="column"
         fxLayoutGap="16px">
        <div fxLayout="row"
             fxLayout.lt-md="column"
             fxLayoutAlign="start end"
             fxLayoutGap="16px">
            <itss-input label="CPF"
                        *ngIf="client?.cpf"
                        mask="000.000.000-00"
                        [disabled]="true"
                        [ngModel]="client.cpf"
                        fxFlex="22"
                        fxFlex.lt-md="100">
            </itss-input>
            <itss-input label="CNPJ"
                        *ngIf="client?.cnpj"
                        mask="00.000.000/0000-00"
                        [disabled]="true"
                        [ngModel]="client.cnpj"
                        fxFlex="22"
                        fxFlex.lt-md="100">
            </itss-input>
            <itss-input label="Cliente"
                        [disabled]="true"
                        [ngModel]="client?.name"
                        fxFlex
                        fxFlex.lt-md="100">
            </itss-input>
            <gipi-datepicker label="Cliente desde"
                             [disabled]="true"
                             [ngModel]="client?.createDate"
                             fxFlex="22"
                             fxFlex.lt-md="100">
            </gipi-datepicker>
        </div>

        <div class="card-information card card-top-five"
             fxLayoutGap="16px"
             fxLayoutAlign="space-between stretch">
            <strong> Top 5 produtos mais comprados </strong>

            <div *ngIf="client?.topFiveMostPurchasedProductsList?.length > 0"
                 fxLayout="row"
                 fxLayoutGap="16px">
                <div class="product-information left">
                    <div class="card-icon">
                        <mat-icon svgIcon="product_top_five"> </mat-icon>
                    </div>

                    <strong> {{ mostPurchasedProduct }} </strong>
                    <span> Item mais comprado </span>
                </div>

                <div class="product-information">
                    <div *ngFor="let product of client?.topFiveMostPurchasedProductsList"
                         class="information">
                        <strong> {{ product?.quantityPurchase }} </strong>
                        <span> {{ product?.description }} </span>
                    </div>
                </div>
            </div>

            <div *ngIf="client?.topFiveMostPurchasedProductsList?.length <= 0"
                 class="no-records">
                <mat-icon>sentiment_very_dissatisfied</mat-icon>
                <span>Nenhum registro foi encontrado</span>
            </div>
        </div>
    </div>

    <div mat-dialog-actions
         fxLayout="row"
         fxLayoutAlign="end center"
         fxLayoutGap="16px">
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnReturn"
                     mat-dialog-close
                     fxFlex="20"
                     fxFlex.lt-md="40">
        </gipi-button>
    </div>
</gipi-abstract-form>